  <div [formGroup]="userDataForm">
      <mat-form-field>
        <input matInput placeholder="Email" formControlName="userSearchCtrl" required=true>
        <mat-error *ngIf="!userDataForm.valid && userDataForm.get('userSearchCtrl').hasError('emailTaken')">
          {{invalidEmailMessage}}
        </mat-error>
        <mat-error *ngIf="!userDataForm.valid &&
         (userDataForm.get('userSearchCtrl').hasError('email') || userDataForm.get('userSearchCtrl').hasError('pattern'))">
          Invalid email format
        </mat-error>
      </mat-form-field>
  </div>

